import React from 'react';
import { graphql } from 'gatsby';
import Slider from 'react-slick';
import LitStructuredText from './generic/LitStructuredText';
import ModularCarouselSlide from './ModularCarouselSlide';
const ModularCarousel = ({ data }) => {
  const { backgroundColor, carouselContent, heading } = data;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    rows: 1,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: true,
    dotsClass: 'slick-dots slick-thumb slick-active',
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          dotsClass: 'slick-dots slick-thumb slick-active',
        },
      },
      {
        breakpoint: 658,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          dotsClass: 'slick-dots slick-thumb slick-active',
        },
      },
    ],
  };

  const carouselContentData = carouselContent?.map(
    ({ heading, body, subheading, smallText, image }, index) => {
      return (
        body && (
          <ModularCarouselSlide
            heading={heading}
            body={body}
            subheading={subheading}
            smallText={smallText}
            image={image}
            index={index}
          />
        )
      );
    },
  );
  return (
    <div className={`modular-carousel-container ${backgroundColor}`}>
      <div className="modular-carousel-inner modular-global-width modular-text-center modular-padding-large">
        <div className="modular-carousel-heading modular-p">
          <LitStructuredText data={heading} basic />
        </div>
        {carouselContent.length > 2 ? (
          <Slider {...settings}>{carouselContentData}</Slider>
        ) : (
          <div className="modular-carousel-no-slide">{carouselContentData}</div>
        )}
      </div>
    </div>
  );
};
export default ModularCarousel;

export const fragment = graphql`
  fragment ModularCarousel on DatoCmsCarousel {
    internal {
      type
    }
    backgroundColor
    heading {
      value
    }
    carouselContent {
      noReadMore
      carouselCard {
        ... on DatoCmsJobVacancyModel {
          id
          slug
          deadline
          jobTitle
          location
          previewText
          publishedDate
          remote
          content {
            value
          }
        }
      }
      heading {
        value
      }
      body
      subheading {
        value
      }
      smallText {
        value
      }
      image {
        gatsbyImageData
      }
    }
  }
`;
